import { icons } from "assets";
import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Menu, MenuItem } from "../menu";
import styles from "./select.module.css";

const CustomSelect = ({
  placeholder,
  optionsValue,
  optionsText,
  options,
  onChange,
  name,
  id,
  className,
  fullWidth,
  error,
  value,
  minWidth,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState(placeholder || options[0]);
  const valueMap = useMemo(() => {
    const map = {};
    for (let opt of options) {
      if (optionsValue) {
        map[optionsValue(opt)] = opt;
      } else {
        map[opt] = opt;
      }
    }
    return map;
  }, [options.length]);
  const menuRef = useRef();
  const clickHandler = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  useEffect(() => {
    const keydownHandler = (e) => {
      if (anchorEl) {
        const menu = menuRef.current?.children?.[0];
        for (let opt = 0; opt < options.length; opt++) {
          if (
            String.fromCharCode(e.keyCode) ==
            (optionsValue ? optionsValue(options[opt])[0] : options[opt][0])
          ) {
            menu.children[opt].scrollIntoView();
          }
        }
      }
    };
    window.addEventListener("keydown", keydownHandler);

    return () => {
      window.removeEventListener("keydown", keydownHandler);
    };
  }, [anchorEl]);
  useEffect(() => {
    if (value && options.length) {
      setSelected(valueMap[value]);
    }
  }, [value, valueMap]);
  return (
    <>
      <button
        onClick={clickHandler}
        id={id}
        className={`${styles.Select} ${
          className ? className : ""
        } row-start space-between
            ${fullWidth ? styles.fullWidth : ""} ${
          error ? styles.errorInput : ""
        }`}
        style={{ gap: "10px", cursor: "pointer", backgroundColor: "unset" }}
      >
        <span>{optionsText ? optionsText(selected) : selected}</span>
        <img src={icons.dropdown} alt="dropdown" />
      </button>
      {error && <small className="errorInput">{error}</small>}
      <Menu
        open={Boolean(anchorEl)}
        variant="static"
        ref={menuRef}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {placeholder && (
          <MenuItem
            onClick={(e) => {
              setSelected(placeholder);
              onChange?.({ target: { name, value: "" } });
              setAnchorEl(null);
            }}
          >
            {placeholder}
          </MenuItem>
        )}
        {options.map((option, index) => {
          return (
            <MenuItem
              className="row-start space-between"
              style={{ gap: "20px", minWidth: minWidth || "180px" }}
              key={index}
              onClick={(e) => {
                setSelected(option);
                onChange?.({
                  target: {
                    name,
                    value: optionsValue ? optionsValue(option) : option,
                  },
                });
                setAnchorEl(null);
              }}
            >
              {optionsText ? optionsText(option) : option}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default CustomSelect;
